// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".underline-offset-transition[data-v-3e4968c8]:after{background:currentColor;bottom:-.3rem;content:\"\";height:.0625rem;left:0;position:absolute;right:0;transition:all .15s}.underline-offset-transition[data-v-3e4968c8]:hover:after{bottom:-.1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
